<template>
  <div class="row py-2">
    <card-default>
      <div
        slot="title"
        class="card-title">
        <div class="h5">
          Translations
        </div>
      </div>
      <div
        slot="body"
        class="row py-2">
        <field-input
          v-model="messageSearch"
          name="messageSearch"
          label="Phrase search"
          class="col"
          @input="search"
        />
        <field-input
          v-model="translationSearch"
          name="translationSearch"
          label="Translation search"
          class="col"
          @input="search"
        />
        <div class="col float-right">
          <auth-button
            class="btn btn-primary btn-micro float-right"
            permission="message-update"
            @click="saveAll"
          >
            Save All Changes
          </auth-button>
        </div>
      </div>
      <div
        slot="body"
      >
        <div class="row py-2">
          <auth-button
            class="btn btn-primary btn-micro float-left"
            permission="message-create"
            @click="ADD_NEW"
          >
            Add new
          </auth-button>
        </div>
        <div>
          <div class="row py-2">
            <div class="col h5">
              Phrase
            </div>
            <div class="col h5">
              Translation
            </div>
            <div class="col-sm-2 h5">
              Context
            </div>
            <div class="col-sm-2"/>
          </div>
        </div>
        <div>

          <div
            v-for="newTranslation in createdTranslations"
            :key="'for-new-' + newTranslation.localId"
            class="row py-2"
          >
            <div class="col">
              <field-textarea
                :key="'new-' + newTranslation.localId"
                v-model="newTranslation.message"
                :name="'new-' + newTranslation.localId"
                :rows="2"
              />
            </div>
            <div class="col">
              <field-textarea
                :key="'new-' + newTranslation.localId"
                v-model="newTranslation.translation"
                :name="'new-' + newTranslation.localId"
                :rows="2"
              />
            </div>
            <div class="col-sm-2">
              <field-select2
                :key="'new-' + newTranslation.localId"
                v-model="newTranslation.context"
                :name="'new-' + newTranslation.localId"
                :options="availableContext"
                :label="''"
                taggable
                searchable
                clear-search-on-select
                @option:created="optionCreated"
              />
            </div>
            <div class="col-sm-2 text-right">
              <div class="btn-group">
                <auth-button
                  class="btn btn-primary btn-micro"
                  permission="message-create"
                  @click="create(newTranslation)"
                >
                  Save
                </auth-button>
                <auth-button
                  class="btn btn-danger btn-micro"
                  permission="message-create"
                  @click="REMOVE_NEW(newTranslation.localId)"
                >
                  <span
                    aria-hidden="true"
                    class="fa fa-remove"/>
                </auth-button>
              </div>
            </div>
          </div>

          <div
            v-for="translation in translationsArray"
            :key="translation.id"
            class="row py-2"
          >
            <div class="col">
              <field-textarea
                v-show="translation.edit"
                v-model="translation.message"
                :name="translation.id"
                :rows="2"
              />
              <div
                v-show="!translation.edit"
              >
                {{ translation.message }}
              </div>
            </div>
            <div class="col">
              <field-textarea
                v-show="translation.edit"
                v-model="translation.translations[activeSite.defaultLanguage.code]"
                :name="translation.id"
                :rows="2"
              />
              <div
                v-show="!translation.edit"
              >
                {{ translation.translations[activeSite.defaultLanguage.code] }}
              </div>
            </div>
            <div class="col-sm-2">
              <field-select2
                v-show="translation.edit"
                v-model="translation.context"
                :name="translation.id"
                :options="availableContext"
                :label="''"
                taggable
                searchable
                clear-search-on-select
                @option:created="optionCreated"
              />
              <div
                v-show="!translation.edit"
              >
                {{ translation.context }}
              </div>
            </div>
            <div class="col-sm-2 text-right">
              <div
                v-show="!translation.edit"
                class="btn-group">
                <auth-button
                  class="btn btn-warning btn-micro"
                  permission="message-update"
                  @click="ALLOW_EDIT(translation)"
                >
                  Edit
                </auth-button>
                <auth-button
                  class="btn btn-danger btn-micro"
                  permission="message-delete"
                  @click="confirmRemove(translation)"
                >
                  <span
                    aria-hidden="true"
                    class="fa fa-remove"/>
                </auth-button>
              </div>
              <div
                v-show="translation.edit"
                class="btn-group">
                <auth-button
                  class="btn btn-warning btn-micro"
                  permission="message-update"
                  @click="update(translation)"
                >
                  Update
                </auth-button>
                <auth-button
                  class="btn btn-danger btn-micro"
                  permission="message-update"
                  @click="cancelEdit(translation)"
                >
                  Cancel
                </auth-button>
              </div>
            </div>
          </div>
        </div>
        <table>
          <pagination
            :page-selected="pageSelected"
            :state="$store.state.translation"/>
        </table>
      </div>
    </card-default>
  </div>
</template>

<script>
import CardDefault from '@/components/CardDefault'
import FieldInput from '@/components/form/FieldInput'
import FieldTextarea from '@/components/form/FieldTextarea'
import FieldSelect2 from '@/components/form/FieldSelect2'
import Pagination from '@/components/Pagination'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { debounce } from 'lodash'

export default {
  name: 'TranslationsList',
  components: {
    FieldInput,
    FieldTextarea,
    FieldSelect2,
    CardDefault,
    Pagination
  },
  data () {
    return {
      messageSearch: '',
      translationSearch: '',
      availableContext: []
    }
  },
  computed: {
    ...mapGetters('translation', [
      'translationsArray',
      'newTranslationsArray'
    ]),
    ...mapGetters({
      activeSite: 'site/active',
      languages: 'language/languages'
    }),
    createdTranslations () {
      return this.newTranslationsArray
    },
    getParams () {
      let params = {
        language: this.activeSite.defaultLanguage.code
      }
      if (this.messageSearch) {
        params.message = this.messageSearch
      }
      if (this.translationSearch) {
        params.translation = this.translationSearch
      }
      return params
    }
  },
  created () {
    this.getContexts().then(response => {
      this.availableContext = response.data.map(context => context.context)
    })
    this.getLanguages().then(() => {
      this.activeSite.defaultLanguage = this.languages[this.activeSite.default_language_id]
      this.get(this.getParams)
    })
  },
  methods: {
    ...mapActions('translation', [
      'get',
      'saveAll',
      'remove',
      'create',
      'update',
      'cancelEdit',
      'getContexts'
    ]),
    ...mapActions({
      getLanguages: 'language/get'
    }),
    ...mapMutations('translation', [
      'ADD_NEW',
      'REMOVE_NEW',
      'ALLOW_EDIT'
    ]),
    confirmRemove (translation) {
      if (confirm('Are you sure you want to delete "' + translation.message + '"?')) {
        this.remove(translation)
      }
    },
    pageSelected (page) {
      const getParams = this.getParams
      getParams.page = page
      this.get(getParams)
    },
    search: debounce(function () {
      this.get(this.getParams)
    }, 300),
    optionCreated (newOption) {
      this.availableContext.push(newOption)
    }
  }
}
</script>
